export default "__VITE_ASSET__BhxwzXwl__"